{
  "0_ALREADY_EXISTS": "\"{0}\" existiert bereits.",
  "0_OF_1": "{0} von {1}",
  "ACCOUNT_ID": "Kontonummer",
  "ADD": "Hinzufügen",
  "ADD_REMOVE_FIELDS": "Felder hinzufügen/entfernen",
  "AN_ERROR_OCCURED": "Ein Fehler ist aufgetreten",
  "APPLY": "Übernehmen",
  "APPLY_CHANGES": "Änderungen übernehmen",
  "ATTACH": "Anhängen",
  "ATTACH_AS_LINK": "Als Link anhängen",
  "ATTACHING": "Anhängen...",
  "AUTOMATICALLY_RENAME": "Automatisch umbenennen",
  "BACK": "Zurück",
  "BROWSE": "Durchsuchen",
  "CANCEL": "Abbrechen",
  "CHARACTER_COUNT": "Zeichenanzahl:",
  "CLOSE": "Schließen",
  "CLOUD": "Cloud",
  "COMMENT": "Kommentar",
  "CONFIGURE_REPOSITORY_SETTINGS": "Repository-Einstellungen konfigurieren",
  "COULD_NOT_SAVE_0": "\"{0}\" konnte nicht gespeichert werden.",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "\"{0}\" konnte nicht gespeichert werden. Dateityp wird nicht unterstützt.",
  "DATA": "Daten",
  "DATE": "Datum",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Datumsfelder müssen im Format {0} sein.",
  "DATE_PROVIDED_IS_INVALID": "Das angegebene Datum ist ungültig.",
  "DATE_TIME": "Datum/Uhrzeit",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Datum/Uhrzeit-Felder müssen im Format {0} sein.",
  "DEFAULT_FOLDER": "<Standardordner>",
  "DETAILS": "Details",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Möchten Sie Ihre Feldänderungen übernehmen?",
  "DOCUMENT_NAME_IS_EMPTY": "Dokumentname ist leer",
  "DRAG_DROP_FILE": "Datei per Drag & Drop",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Ein Eintrag mit dem Namen '{0}' existiert bereits in diesem Ordner. Bitte wählen Sie einen anderen Namen.",
  "ENTRY_ID": "Eintrags-ID",
  "ENTRY_NAME": "Eintragsname",
  "ENTRY_NOT_FOUND": "Eintrag nicht gefunden.",
  "ERROR_DOWNLOADING_DOCUMENT": "Fehler beim Herunterladen des Dokuments.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Beim Verbinden mit dem Server ist ein Fehler aufgetreten.",
  "ERROR_SAVING": "Fehler beim Speichern:",
  "FAILED_TO_OPEN_FOLDER": "Ordner konnte nicht geöffnet werden",
  "FAILED_TO_SAVE_COLON": "Speichern fehlgeschlagen:",
  "FAILED_TO_SAVE_PERIOD": "Speichern fehlgeschlagen.",
  "FEEDBACK": "Feedback",
  "FIELDS": "Felder",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Diese Datei überschreitet die maximale Dateigröße von 25 MB.",
  "FILE_EXTENSION": "Dateierweiterung",
  "FILE_LOCKED": "Datei ist gesperrt.",
  "FILE_MODIFIED": "Datei geändert",
  "FILE_NAME": "Dateiname",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Dateinamen dürfen keinen Rückwärtsschrägstrich enthalten",
  "FOLDER": "Ordner",
  "INTEGER": "Ganzzahl",
  "LIST": "Liste",
  "LOADING": "Wird geladen...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Long-Felder müssen Ganzzahlen zwischen 0 und 3.999.999.999 sein",
  "LONG_INTEGER": "Long-Ganzzahl",
  "NAME": "Name",
  "NAME_CONFLICT": "Namenskonflikt",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Benötigen Sie Hilfe beim Anmelden? Wenden Sie sich an Ihren Laserfiche-Administrator.",
  "NEW_FOLDER": "Neuer Ordner",
  "NO": "Nein",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Keine zusätzlichen Felder zugewiesen",
  "NO_FOLDER_SELECTED": "Kein Ordner ausgewählt.",
  "NO_MATCHING_ENTRIES_FOUND": "Keine passenden Einträge gefunden",
  "NO_MATCHING_FIELDS_FOUND": "Keine passenden Felder gefunden.",
  "NO_TEMPLATE_ASSIGNED": "Keine Vorlage zugewiesen",
  "NOT_AVAILABLE_WITH_TOKENS": "Mit Tokens nicht verfügbar",
  "NUMBER": "Nummer",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "Das Zahlenfeld muss eine gültige Zahl enthalten",
  "OK": "Ok",
  "ONE_OR_MORE_FIELDS_INVALID": "Ein oder mehrere Felder sind ungültig.",
  "OPEN": "Öffnen",
  "OPEN_IN_LASERFICHE": "In Laserfiche öffnen",
  "OPTIONAL": "Optional",
  "OR": "oder",
  "PARENT_FIELD": "Übergeordnetes Feld",
  "PARENT_ID": "Übergeordnete ID",
  "PARENT_NAME": "Übergeordneter Name",
  "PLEASE_SELECT_A_FOLDER": "Bitte wählen Sie einen Ordner aus",
  "REASON_FOR_DOWNLOADING": "Grund für den Download",
  "REFRESH": "Aktualisieren",
  "REMOVE": "Entfernen",
  "REMOVE_REPOSITORY": "Repository entfernen?",
  "REPOSITORY": "Repository",
  "REPOSITORY_COUNT": "Anzahl der Repositories",
  "REPOSITORY_ID": "Repository-ID",
  "REPOSITORY_NAME": "Repository-Name",
  "REQUIRED": "Erforderlich",
  "REQUIRED_FIELD_IS_EMPTY": "Pflichtfeld ist leer",
  "SAVE_CHANGES": "Änderungen speichern",
  "SAVE_TO_LASERFICHE": "In Laserfiche speichern",
  "SAVED_TO_LASERFICHE": "In Laserfiche gespeichert",
  "SAVED_TO_LASERFICHE_COLON": "In Laserfiche gespeichert:",
  "SAVED_WITH_MISSING_METADATA": "Mit fehlenden Metadaten gespeichert:",
  "SAVING": "Speichern...",
  "SEARCH_FIELDS": "Suchfelder",
  "SELECT": "Auswählen",
  "SELECT_REASON": "Wählen Sie einen Grund aus",
  "SELF_HOSTED": "Selbst gehostet",
  "SESSION_COUNT": "Sitzungsanzahl",
  "SETTINGS": "Einstellungen",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Short-Felder müssen Ganzzahlen zwischen 0 und 64999 sein",
  "SIGN_IN": "Anmelden",
  "SIGN_IN_TO_LASERFICHE": "Bei Laserfiche anmelden",
  "SIGN_OUT": "Abmelden",
  "SIGNING_IN": "Anmeldung läuft...",
  "SIGNING_OUT": "Abmeldung läuft...",
  "SKIP_THIS_FILE": "Diese Datei überspringen",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.",
  "SUBMIT": "Absenden",
  "SUGGESTION": "Vorschlag",
  "TEMPLATE": "Vorlage",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "Die Vorlage konnte nicht geladen werden.",
  "TEXT": "Text",
  "THANK_YOU_FOR_SUBMISSION": "Vielen Dank für Ihre Eingabe!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Dieses Feld hat eine maximal zulässige Länge von {0} Zeichen.",
  "THIS_FOLDER_IS_EMPTY": "Dieser Ordner ist leer.",
  "TIME": "Uhrzeit",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Zeitfelder müssen im Format {0} sein.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Alle Felder konnten nicht geladen werden:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Repository-Informationen können nicht abgerufen werden:",
  "UNKNOWN_ERROR": "Unbekannter Fehler.",
  "USER_NAME": "Benutzername",
  "YES": "Ja"
}
